import React, { useContext, useEffect, Fragment, useState } from 'react';
import { Field } from 'formik';
import { TextField } from 'formik-material-ui';
import { Grid, Typography } from '@material-ui/core';
import { FieldError } from '../../../../common';
import { AddressForm } from '../common/AddressForm';
import { CustomerRequestContext } from '../../CustomerRequestContext';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
    invalidField: {        
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1)
    }
}));

export const PayerForm = (props) => {
    const classes = useStyles();
    const { formSuffixName } = props

    const {
        state
    } = useContext(CustomerRequestContext);

    return (
        <Grid container spacing={3}>  
            <Grid item xl={12} md={12} xs={12}>
                <Field
                    type="text"
                    className={classes.field}
                    name={`${formSuffixName}.name`}
                    variant="outlined"
                    label="Name *"
                    disabled={props.disabled}
                    component={TextField} 
                />
                <FieldError name={`${formSuffixName}.name`} errors={state.errors} />
            </Grid>
            <Grid item xl={12} md={12} xs={12}>
                <AddressForm 
                    formSuffixName={`${formSuffixName}.address`} 
                    disabled={props.disabled} 
                />
            </Grid>
            {/* <Grid item xl={6} md={12} xs={12}>
                <Field
                    type="text"
                    className={classes.field}
                    name={`${formSuffixName}.sapCode`}
                    variant="outlined"
                    label="SAP code *"
                    disabled={props.disabled}
                    component={TextField} 
                />
                <FieldError name={`${formSuffixName}.sapCode`} />
            </Grid> */}
            <Grid item xs={12} md={6} xl={6/*props.hasSDICode ? 4 : 6*/}>
                <Field
                    type="text"
                    className={classes.field}
                    name={`${formSuffixName}.phone`}
                    variant="outlined"
                    label="Phone *"
                    disabled={props.disabled}
                    component={TextField} 
                />
                <FieldError name={`${formSuffixName}.phone`} errors={state.errors} />
            </Grid>
            <Grid item xs={12} md={6} xl={6/*props.hasSDICode ? 4 : 6*/}>
                <Field
                    type="text"
                    className={classes.field}
                    name={`${formSuffixName}.email`}
                    variant="outlined"
                    label="Email *"
                    disabled={props.disabled}
                    component={TextField} 
                />
                <FieldError name={`${formSuffixName}.email`} errors={state.errors} />
            </Grid>            
            <Grid item xs={12} md={12} xl={6}>
                <Field
                    type="text"
                    className={classes.field}
                    name={`${formSuffixName}.vatNumber`}
                    variant="outlined"
                    label="Vat Number *"
                    disabled={props.disabled}
                    component={TextField}
                />
                <FieldError name={`${formSuffixName}.vatNumber`} errors={state.errors} />
            </Grid>
            <Grid item xs={12} md={12} xl={6}>
                <Field
                    type="text"
                    className={classes.field}
                    name={`${formSuffixName}.taxNumber`}
                    variant="outlined"
                    label="TAX Number"
                    disabled={props.disabled}
                    component={TextField} 
                />
                <FieldError name={`${formSuffixName}.taxNumber`} errors={state.errors} />
            </Grid>
            {props.hasSDICode && (
                <Grid item xs={12} md={12} xl={12/*4*/}>
                    <Field
                        type="text"
                        className={classes.field}
                        name={`${formSuffixName}.sdiCode`}
                        variant="outlined"
                        label="SDI Code *"
                        disabled={props.disabled}
                        component={TextField} 
                    />
                    <FieldError name={`${formSuffixName}.sdiCode`} errors={state.errors} />
                </Grid>
            )}
            {props.hasIBAN && (
                <Grid item xs={12} md={6} xl={6}>
                    <Field
                        type="text"
                        className={classes.field}
                        name={`${formSuffixName}.bankIBAN`}
                        variant="outlined"
                        label="IBAN *"
                        disabled={props.disabled}
                        component={TextField}
                    />
                    <FieldError name={`${formSuffixName}.bankIBAN`} errors={state.errors} />
                </Grid>
            )}
            {props.hasSwiftBic && (
                <Grid item xs={12} md={6} xl={6}>
                    <Field
                        type="text"
                        className={classes.field}
                        name={`${formSuffixName}.swiftBic`}
                        variant="outlined"
                        label="SWIFT/BIC *"
                        disabled={props.disabled}
                        component={TextField}
                    />
                    <FieldError name={`${formSuffixName}.swiftBic`} errors={state.errors} />
                </Grid>
            )}
        </Grid>
    );
}